<template>
  <div class="orderList">
      <div v-if="!isLogin">
        <el-empty description="登录后查看"></el-empty>
      </div>

      <div v-if="isLogin">
        <!-- 数据列表 -->
        <h3>报价记录</h3>
        <el-table
          :data="orderList"
          stripe
          style="width: 100%">
          <el-table-column
            prop="_title"
            label="标题">
            <template slot-scope="scope">
              <el-button @click="orderDntry(scope.row)" type="text" size="small">{{scope.row._title}}</el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="_sts"
            label="当前状态"
            width="100">
          </el-table-column>
          <el-table-column
            prop="_bsts"
            label="是否中标"
            width="100">
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="我报价的时间"
            width="160">
          </el-table-column>
          <el-table-column
            prop="finsh_time"
            label="项目关闭时间"
            width="160">
          </el-table-column>
        </el-table>

        <!-- 分页效果 -->
        <el-pagination
          @size-change="pageSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          stripe="true"
          :total="total">
        </el-pagination>
      </div>

  </div>
</template>
<script>
import { Log } from '../../api';
export default {
  data(){
    return {
      orderList:[],
      isLogin:window.localStorage.getItem('hasLogin'),
      
      sts:1,
      currentPage:0,
      pageSize:10,
      total:0,
    }
  },
  mounted(){
    if (this.isLogin) {
      this.getOrderList();
    }
  },
  methods:{
    getOrderList(){ //获取默认订单列表
      var that = this;
      var postData = {
        cate_id:this.cate_id,
        sts:this.sts,
        currentPage:this.currentPage,
        pageSize:this.pageSize
      };
      //订单请求
      Log(postData).then(res=>{
        if (res.code == 200) {
          that.currentPage = res.data.currentPage;
          that.total = parseInt(res.data.total);
          that.orderList = res.data.list;
        }
      })
    },
    handleCurrentChange(val){ //跳转到某页
      this.currentPage = val;
      this.getOrderList();
    },
    pageSizeChange(val){// 更换每页条数处理
      this.pageSize = val;
      this.getOrderList();
    },
    orderDntry(e){ //查看订单详情
      let routerUrl = this.$router.resolve({
        path:'/orderDetail',
        query:{code:e.code,id:e.id}
      });
      window.open(routerUrl.href,'_blank')
    }

  }
}
</script>